export const FileType = {
  JSON: "application/json",
  CSV: "text/csv;charset=utf-8;"
};
